export default {
  viewType: 'poc-project-detail',
  breadcrumb: {
    title: '',
    action: '',
    class: ''
  },
  params: {}
}
